import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      sidebarState: state => state.app.sidebar.opened
    })
  },
  methods: {
    // util
    // relative to all page/viewport
    getMouseEventPosition(e) {
      let posx = 0
      let posy = 0

      if (e.pageX || e.pageY) {
        posx = e.pageX
        posy = e.pageY
      } else if (e.clientX || e.clientY) {
        posx =
          e.clientX +
          document.body.scrollLeft +
          document.documentElement.scrollLeft
        posy =
          e.clientY +
          document.body.scrollTop +
          document.documentElement.scrollTop
      }

      return {
        x: posx,
        y: posy
      }
    },
    // return an element, which be clicked, has className or has child node having className, else return false
    clickInsideCtxMenu(e, className) {
      let el = e.srcElement || e.target

      if (el.classList.contains(className)) {
        return el
      } else {
        while ((el = el.parentNode)) {
          if (el.classList && el.classList.contains(className)) {
            return el
          }
        }
      }
      return false
    },
    // place context menu
    positionMenu(e, contextMenuIdSelector) {
      const menu = document.querySelector(contextMenuIdSelector)

      const clickCoords = this.getMouseEventPosition(e) // relative to viewport
      const clickCoordsX = clickCoords.x
      const clickCoordsY = clickCoords.y

      setTimeout(() => {
        const menuWidth = menu.offsetWidth
        const menuHeight = menu.offsetHeight

        const windowWidth = window.innerWidth
        const windowHeight = window.innerHeight
        // menu.style.left = clickCoordsX - 260 + 'px'
        // menu.style.top = clickCoordsY - 70 + 'px'
        if (windowWidth - clickCoordsX < menuWidth) {
          menu.style.left =
            clickCoordsX - (this.sidebarState ? 260 : 72) - menuWidth + 'px' // 260px is width of open sidebar
        } else {
          menu.style.left = clickCoordsX - (this.sidebarState ? 260 : 72) + 'px' // 72px is width of closed sidebar
        }
        if (windowHeight - clickCoordsY < menuHeight) {
          menu.style.top = clickCoordsY - 70 - menuHeight + 'px' // 70px is height of header
        } else {
          menu.style.top = clickCoordsY - 70 + 'px'
        }
      }, 0)
    }
  }
}
